/**
 * This file is used to configure different app client for this project based on the URL
 */

import awsmobile from "../amplify_outputs.json";
import amplifyAppClients from "./appClientsConfig";
import { Amplify } from "aws-amplify";
import { signInWithRedirect } from "aws-amplify/auth";
import { parseAmplifyConfig } from "aws-amplify/utils";
import { getENV } from "../stores/consts";

/**
 * This function will consider the URL params and the
 */
export default function ConfigureApp() {
  // Get the provider from the URL. Should only consider if the URL is /auth/sign-in/<provider>...
  const urlRoute = window.location.pathname;
  const provider = window.location.pathname.split("/")[3];

  ConfigureAmplify();

  // Check the URL, if there is no callback, then do a federated sign in
  if (
    !urlRoute.includes("callback") &&
    Object.keys(amplifyAppClients).includes(provider)
  ) {
    signInWithRedirect({ provider: { custom: awsmobile.auth.user_pool_id } });
  }
}

export function ConfigureAmplify() {
  // Gen2 REST APIs live in amplify_outputs `custom.API`. Amplify.configure does
  // NOT auto-map them to `API.REST`, so wire them up manually (migration guide).
  // The keys carry the backend branch suffix ("BlingsAPI-gen2-master") but the
  // app calls them by bare name ("BlingsAPI"), and the base names never contain
  // a dash, so take everything before the first one (survives dashed branches).
  const restApi = Object.fromEntries(
    Object.entries((awsmobile as any).custom?.API ?? {}).map(([name, cfg]) => [
      name.split("-")[0],
      cfg,
    ])
  );
  const baseConfig = parseAmplifyConfig(awsmobile);

  // Point GraphQL + REST at the custom domains (dev.* on dev; bare host on
  // staging/master), preserving the Gen1 behavior. Guard each override: if the
  // generated outputs are missing a resource (e.g. the backend branch didn't
  // deploy data/GraphQL or the BlingsAPI REST api), a bare `!` access would
  // throw here and PREVENT Amplify.configure() from running at all — which
  // surfaces later as the misleading "Auth UserPool not configured". Fail
  // loudly instead, and still configure Amplify so Auth keeps working.
  const prefix = getENV() === "dev" ? "dev." : "";
  if (baseConfig.API?.GraphQL) {
    baseConfig.API.GraphQL.endpoint = `https://${prefix}graphql.blings.io/graphql`;
  } else {
    console.error(
      "[amplifyConfig] amplify_outputs.json has no GraphQL/data resource — " +
        "GraphQL endpoint not overridden. Check `ampx generate outputs` for this branch."
    );
  }
  if (restApi.BlingsAPI) {
    (restApi.BlingsAPI as any).endpoint = `https://${prefix}api.blings.io`;
  } else {
    console.error(
      "[amplifyConfig] amplify_outputs.json has no custom.API.BlingsAPI entry — " +
        "REST endpoint not overridden. Check `ampx generate outputs` for this branch."
    );
  }

  // ponytail: the per-provider app clients in ./appClientsConfig are Gen1-shaped
  // and no longer applied — same as platform. Re-add if a custom provider needs
  // its own user-pool client; today they only feed CheckIfProviderExists.
  Amplify.configure({
    ...baseConfig,
    API: { ...baseConfig.API, REST: restApi as any },
  });
}

export function CheckIfProviderExists(providerName: string) {
  return Object.keys(amplifyAppClients).includes(providerName);
}

//http://localhost:3102/auth/sign-in/?provider=sample
